module.exports = __webpack_public_path__ + "static/media/IMG_8701.c2452734.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/horizontal/IMG_8701.jpg
// module id = 150
// module chunks = 0